export class MonitoreoConfiguracionTiempo {
    id:string;
    minutos: number;
    color:string;
    detalle:string;
}